export const pageURLSearchParamsName = 'page'
export const pageSizeURLSearchParamsName = 'size'
export const visibleByGuildIdUrlSearchParamsName = 'visibleByGuildId'
export const phraseUrlSearchParamsName = 'phrase'
export const partNumberSearchParamsName = 'partNumber'
export const labelSearchParamsName = 'label'
export const idSearchParamsName = 'datxId'

export const organizationFilterSearchParamsName = 'organizationFilter'
export const itemTypeFilterSearchParamsName = 'itemTypeFilter'
export const isPublicSearchParamsName = 'isPublic'
export const filtersSearchParamsName = 'filters'

export const managedByGuildIdUrlSearchParamsName = 'managedByGuildId'

export const workflowGuildId = 'workflowGuildId'

export const notDefinedByOrganizationsUrlParamsName = 'notDefinedByOrganizations'